/**
 * 评估报告管理
 */
import React from 'react';
import { Input, Button, Row, Col, Icon, Tooltip, DatePicker } from 'antd';
import PageLayout from '../../ui/PageLayout';
import http from '../../../axios/http';
// //信息编辑
import DocumentGenerationEdit from './DocumentGenerationEdit';
//消息提示
import messager from '../../ui/messager';
//加载中遮罩
import Loading from '../../ui/Loading';
import { global_data } from '../../ui/auth'

class DocumentGenerationIndex extends React.Component {
    columns = [{
        title: '创建时间',
        dataIndex: 'insertTime',
        width: '10%',
    }, {
        title: '最后编辑时间',
        dataIndex: 'updateTime',
        width: '10%',
    }, {
        title: '公司名称',
        dataIndex: 'companyName',
        width: '12%',
    }, {
        title: '车牌号',
        dataIndex: 'plateNo',
        width: '6%',
    }, {
        title: '车架号',
        dataIndex: 'vin',
        width: '12%',

    }, {
        title: '评估报告号',
        dataIndex: 'evaluationNo',
        width: '8%',
    }, {
        title: '电子签章申请状态',
        dataIndex: 'signApplyStatus',
        width: '8%',
        format: {
            "NOT_START": "未开始", "START": "业务发起审核",
            "SUBMIT": "提交申请", "DEPARTMENT_MANAGER": "部门经理审核", "GENERAL_MANAGER": "总经理审核",
            "ADMINISTRATIVE": "行政审核", "FAIL": "未通过", "SUCCESS": "已通过"
        }
    }, {
        title: '电子签章状态',
        dataIndex: 'signTaskStatus',
        width: '8%',
        format: { 9: "未发起签署", 0: "草稿", 1: "签署中", 2: "完成", 3: "撤销", 5: "过期", 7: "拒签" },
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '20%',
        render: (text, record, index) => (
            <div>
                {global_data.authCode.includes("MALL_DOCUMENT_GENERATION_UPDATE")?
                <Tooltip title="修改信息">
                    <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.update.bind(this, record.id)} />
                </Tooltip>
                :""}
                <Tooltip title="下载未签署的评估报告">
                    <Icon type="download" className="table-operate-icon" onClick={this.download.bind(this, record, "detail")} />
                </Tooltip>
                {/* <Tooltip title="下载简版文件">
                    <Icon type="download" className="table-operate-icon" onClick={this.download.bind(this, record, "simple")} />
                </Tooltip> */}
                {global_data.authCode.includes("MALL_DOCUMENT_GENERATION_COPY")?
                <Tooltip title="复制">
                    <Icon type="copy" theme="filled" className="table-operate-icon" onClick={this.copy.bind(this, record.id)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("MALL_DOCUMENT_GENERATION_DELETE")?
                <Tooltip title="删除">
                    <Icon type="delete" theme="filled" className="table-operate-icon" onClick={this.delete.bind(this, record.id)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("MALL_DOCUMENT_GENERATION_SIGN")?
                <Tooltip title="发起整评估报告签署流程">
                    <Icon type="form" className="table-operate-icon" onClick={this.startFlow.bind(this, record)} />
                </Tooltip>
                :""}
                {
                    record.signTaskStatus === 2 ?
                        <Tooltip title="下载已签署完成的评估报告">
                            <Icon type="download" className="table-operate-icon" onClick={this.download.bind(this, record, "finished")} />
                        </Tooltip>
                        : ''
                }
            </div>
        ),
    }];

    state = {
        visible: false,
        loadData: '',
        editData: {},   //编辑页面使用的数据
        detailData: {},  //详情页面使用的数据
        queryData: {}, //查询数据
        loadingVisible: false,
    };

    componentDidMount() {

    }
    format = (m) => {
        return m < 10 ? '0' + m : m
    }
    add = () => {
        let date = new Date();
        let evaluationDate = date.getFullYear() + '-' + this.format(date.getMonth() + 1) + '-' + this.format(date.getDate());
        this.setState({
            editData: {
                technicalCondition: '0',
                maintenance: '0',
                quality: '0',
                workProperty: '0',
                workCondition: '0',
                technicalConditionScore: '0.315',
                maintenanceScore: '0.180',
                qualityScore: '0.135',
                workPropertyScore: '0.135',
                workConditionScore: '0.135',
                mortgage: 0,
                purchaseTax: 0,
                overdrive: 1,
                brandRecognition: 1,
                technologyUpgrade: 1,
                stopProduction: 1,
                overdriveScore: 0.3,
                brandRecognitionScore: 0.3,
                technologyUpgradeScore: 0.2,
                stopProductionScore: 0.2,

                purchasePrice: 0,        //购置价格
                relatedExpenses: 0.1,  //车辆购置相关费用
                additionalTaxRate: 0.13,  //购置附加税率
                serviceLife: 15,  //规定使用年限
                serviceLifeMonth: 180,  //规定年限折合月
                newRate: "100%",  //年限成新率
                adjustmentFactorAdd: 0,
                adjustmentFactorMinus: 0,

                totalCoefficient: "100%",  //合计系数

                totalScore: '90%',   //合计得分
                synthesisCoefficient: "90%",   //综合系数 = 合计得分*合计系数
                evaluationDate: evaluationDate,
                registerDate: evaluationDate,
                // originalBookValue:0,
                // bookValue:0,
                valueAddRate: 0,
                businessType: "6",
                usedMonth: this.monthDiff(evaluationDate, evaluationDate)
            }
        });
        this.showModal();
    }


    update = (info, e) => {
        this.setState({ loadingVisible: true });
        http.get({
            url: '/evaluation/detail',
            data: { id: info },
            success: (res) => {
                if (res.adjustmentFactorAdd === null) {
                    res.adjustmentFactorAdd = 0
                }
                if (res.adjustmentFactorMinus === null) {
                    res.adjustmentFactorMinus = 0
                }

                let calculationFormula = "￥" + (res.purchasePrice * (1 + res.relatedExpenses)).toFixed(2) + "X" + res.synthesisCoefficient + "X" + res.newRate + "%+" +
                    res.adjustmentFactorAdd + "-" + res.adjustmentFactorMinus + "=" + res.evaluationValue;
                res.calculationFormula = calculationFormula;
                res.additionalTax = (res.purchasePrice / (1 + res.additionalTaxRate) * 0.1).toFixed(2)
                this.setState({ editData: res });
                this.setState({ loadingVisible: false });
                this.showModal();
            },
            error: () => {
                this.setState({ loadingVisible: false });
            }
        });
    }
    monthDiff = (date1, date2) => {
        // 拆分年月du日zhi
        date1 = date1.split('-');
        // 得到月数dao
        date1 = parseInt(date1[0]) * 12 + parseInt(date1[1]);
        // 拆分年月日
        date2 = date2.split('-');
        // 得到月数
        date2 = parseInt(date2[0]) * 12 + parseInt(date2[1]);
        var m = Math.abs(date1 - date2);
        return m;
    }
    transferData = (res, field) => {
        let buyer = res[field];
        for (let key in buyer) {
            res[field + "." + key] = buyer[key];
        }
        delete res[field];
    }
    delete = (info, e) => {
        messager.confirm("是否删除该文书？", () => {
            http.post({
                url: '/evaluation/delete',
                data: { id: info },
                success: (res) => {
                    this.state.loadData();
                    messager.notify("删除成功！");
                }
            });
        });
    }
    detail = (info, e) => {
        http.post({
            url: '/application/findApplicationDetail',
            data: { applicationId: info },
            success: (res) => {
                this.transferData(res, "buyer");
                this.transferData(res, "seller");
                this.transferData(res, "vehicle");
                //this.transferData(res, "ticket");
                res["vehicle.isImported"] = res["vehicle.isImported"] === 1 ? '是' : '否';
                res["agent"] = res["agent"] === 1 ? '是' : '否';
                this.setState({ detailData: res });
                this.showModalDetal();
            }
        });
    }

    showModal = () => {
        this.setState({ visible: true });
    }
    hiddenModal = () => {
        this.setState({ visible: false, editData: {} });
    }
    showModalDetal = () => {
        this.setState({ detailVisible: true });
    }
    hiddenModalDetail = () => {
        this.setState({ detailVisible: false });
    }

    download = (info, type) => {
        this.setState({ loadingVisible: true });
        let url = '';
        let fileName = ''
        let data;
        if (type === 'detail') {
            url = '/evaluation/download/detail'
            fileName = "车辆资产评估_报告_" + info.plateNo + ".docx";
            data = { "id": info.id, type: 'docx' };
        } else if (type === 'simple') {
            url = '/evaluation/download/simple'
            fileName = "车辆资产评估_报告（简版）_" + info.plateNo + ".docx";
            data = { "id": info.id, type: 'docx' };
        } else if (type === "summary") {
            url = "/evaluation/downloadSummary";
            fileName = "车辆评估汇总信息.xlsx";
            data = this.state.queryData;
            //下载条数设置为5000
            data.pageSize=5000;
            if (data.startDate == null || data.startDate === "") {
                messager.notify("请选择时间段进行导出！");
                this.setState({ loadingVisible: false });
                return;
            }
        } else if (type === "finished") {
            url = "/evaluation/downloadFinishedReport";
            fileName = "车辆资产评估_报告_电子签章版_" + info.plateNo + ".pdf";
            data = { "id": info.id, type: 'docx' };
        }
        http.download({
            url: url,
            data: data,
            fileName: fileName,
            success: (res) => {
                this.setState({ loadingVisible: false });
            },
            error: (res) => {
                messager.alert(res);
                this.setState({ loadingVisible: false });
            }
        });
    }

    startFlow = (info, type) => {
        messager.confirm("是否发起签字签章的审核流程？", () => {
            http.post({
                url: '/evaluation/createChapterApplyflow',
                data: { id: info.id },
                success: (res) => {
                    this.state.loadData();
                    messager.notify("发起电器签章成功！");
                }
            });
        });
    }

    copy = (id) => {
        this.setState({ loadingVisible: true });
        http.post({
            url: "/evaluation/copy",
            data: { "id": id },
            success: (res) => {
                this.state.loadData();
                this.setState({ loadingVisible: false });
            },
            error: (res) => {
            }
        });
    }


    reloadDataFunc = () => {
        this.state.loadData();
        if (this.state.ticketVisible) {
            this.printTicket(this.state.ticketData.applicationId);
        } else if (this.state.printVisible) {
            this.printApplication(this.state.printData.applicationId);
        }
    }

    inputSearch = (value) => {
        let queryData = this.state.queryData;
        queryData.queryString = value
        this.state.loadData(queryData);
        this.setState({ queryData: queryData });
    }

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    selectChange = (value) => {
        let queryData = this.state.queryData;
        queryData.invoiceState = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }


    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={20}>
                                <Input.Search
                                    placeholder="车牌号/车架号"
                                    onSearch={this.inputSearch}
                                    enterButton
                                    style={{ width: '250px', marginRight: '30px' }}
                                />
                                <DatePicker.RangePicker onChange={this.rangePickerChange} style={{ marginRight: '10px' }} />
                            </Col>
                            <Col span={4} style={{ textAlign: "right" }}>
                                {global_data.authCode.includes("MALL_DOCUMENT_GENERATION_ADD")?
                                <Button type="primary" onClick={this.add} style={{ marginRight: '10px' }}>新增</Button>
                                :""}
                                <Button type="primary" onClick={this.download.bind(this, {}, "summary")}>导出</Button>
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/evaluation/page"
                    requestType="get"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />

                <DocumentGenerationEdit
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    editData={this.state.editData}
                    successCallback={this.reloadDataFunc}
                />
                {/* <ApplicationDetail
                    visible={this.state.detailVisible}
                    onCancel={this.hiddenModalDetail.bind(this)}
                    detailData={this.state.detailData}
                /> */}

                <Loading
                    visible={this.state.loadingVisible}
                    message="数据加载中"
                />
            </div>
        )
    }

}

export default DocumentGenerationIndex;